import { render, staticRenderFns } from "./headSteps.vue?vue&type=template&id=7bc7e7e1&"
import script from "./headSteps.vue?vue&type=script&lang=js&"
export * from "./headSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "headSteps.vue"
export default component.exports